import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AmountField from "../../../common/components/functional/AmountField";
import { AutocompleteType } from "../../../common/types/autoComplete";
import { OrderFields, autoCompleteDefaultValue } from "../orderTypes";
import { OrderFieldsProperties } from "./types";

type Props = {
  values: OrderFields;
  handleChangeCallback: (
    name: OrderFieldsProperties,
    newValue:
      | AutocompleteType[]
      | AutocompleteType
      | Date
      | null
      | number
      | string
      | boolean,
  ) => void;
};

const BasicInfo = ({ values, handleChangeCallback }: Props) => {
  const { t } = useTranslation("order");

  return (
    <>
      <Grid container item xs={4} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("workLocation")}</Typography>
      </Grid>
      <Grid item xs={8}>
        <Autocomplete
          readOnly
          sx={{
            backgroundColor: "rgba(249, 249, 250, 0.6)",
            width: "363px",
          }}
          value={values.workLocation}
          options={[]}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField {...params} size="small" name="workLocation" />
          )}
          onChange={(_, newValue: AutocompleteType | null) => {
            handleChangeCallback(
              "workLocation",
              newValue || {
                ...values.orderTemplate,
                ...autoCompleteDefaultValue,
              },
            );
          }}
          disabled
        />
      </Grid>
      <Grid container item xs={4} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("orderTemplate")}</Typography>
      </Grid>
      <Grid item xs={8}>
        <Autocomplete
          readOnly
          sx={{
            backgroundColor: "rgba(249, 249, 250, 0.6)",
            width: "363px",
          }}
          value={values.orderTemplate}
          getOptionLabel={(option) => option.name}
          options={[]}
          disabled
          renderInput={(params) => (
            <TextField {...params} size="small" name="orderTemplate" />
          )}
          onChange={(e, newValue: AutocompleteType | null) => {
            handleChangeCallback(
              "orderTemplate",
              newValue || {
                ...values.orderTemplate,
                ...autoCompleteDefaultValue,
              },
            );
          }}
        />
      </Grid>
      <Grid container item xs={4} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("amount")}</Typography>
      </Grid>
      <Grid item xs={8}>
        <AmountField
          sx={{ width: "140px" }}
          size="small"
          value={values.amount}
          onChange={(value: number) => handleChangeCallback("amount", value)}
          min={1}
          max={250}
        />
      </Grid>
    </>
  );
};

export default BasicInfo;
